module.exports = __webpack_public_path__ + "img/Frame 1143one.90f46328.png";